/* eslint-disable require-jsdoc */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import AppRouter from './components/navigation/AppRouter';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import './App.css';
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from './assests';
import { Provider } from 'react-redux';
import configureStore from './store'
import store from './store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css'

// const store= configureStore();




class App extends Component {
  render() {
    return (
      <div className="App">

        <ToastContainer
          // autoClose={false}
        />
        <Provider store={store}>

          <MuiThemeProvider theme={theme}>
            <AppRouter theme={theme}></AppRouter>

          </MuiThemeProvider>
        </Provider>
      </div>
    );
  }
}

export default App;



